import React, { useContext, useRef, useState } from 'react'
import { toast } from 'react-toastify';
import List from '../component/component/todo/List';
import { StarterContext } from '../store/Starter';
function Todo({ classes, title }) {
    const { state, todoAdd } = useContext(StarterContext)
    const ref = useRef('')
    const [todoInput, settodoInput] = useState("")
    const todo = (e) => {
        e.preventDefault()
        if (todoInput.length === null || todoInput.length === "" || todoInput.length === 0) {
            toast.error('Please Insert Every Field')
        } else {  
            todoAdd(todoInput)
            settodoInput("");
            toast.success('Todo Added')
            ref.current.value = ""
        }
    }
    return (
        <>
            <div className="container">
                <h1 className={classes}>{title}</h1>
                <div className="inputField card">
                    <div className="row">
                        <form className="col l6 s12 offset-l3" onSubmit={todo} >
                            <div className="row">
                                <div className="input-field col s12">
                                    <i className="material-icons prefix">account_circle</i>
                                    <input id="icon_prefix" ref={ref} type="text" onChange={(e) => settodoInput(e.target.value)} className="validate" />
                                    <label >Todo</label>
                                    <button className="btn blue waves-effect waves-light" type="submit">Add Todo
                                         <i className="material-icons right">send</i>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="todoList card">
                    <ul>
                        {
                            state.length !== 0 ?
                                state.map((element, i) => {
                                    return <List key={i} element={element} i={i} />
                                })
                            :
                            <h1>Please Add Todo 😄</h1>
                        }
                    </ul>
                </div>
            </div>
        </>
    )
}

export default Todo
